const PUBLIC_STANDALONE_PATHS = [
  "/qr-scan",
  "/fleet-manager/revise",
  "/fuel-vendor/revise",
  "/payment/success",
  "/payment/failed",
];

export default PUBLIC_STANDALONE_PATHS;
